var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFjfs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "cd21a4fb-c192-4878-8926-f12bc8b58ad5"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "f894d967-ea43-447e-9468-2c789e7c5a40"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 0.33 -139.89)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4489.27, -5344.73)",
    d: "M 3415 6949 C 3308 6894 3296 6888 3235 6855 C 3134 6800 3110 6785 3110 6778 C 3110 6773 3105 6770 3100 6770 C 3091 6770 3035 6735 3020 6720 C 3017 6717 2997 6703 2975 6689 C 2852 6609 2584 6348 2469 6195 C 2395 6096 2296 5950 2269 5898 C 2234 5832 2151 5661 2136 5625 C 2126 5603 2115 5576 2110 5565 C 2098 5540 2072 5465 2060 5425 C 2007 5248 2013 5272 1959 5005 C 1952 4971 1945 4826 1943 4675 C 1939 4457 1941 4383 1955 4290 C 1973 4162 1994 4058 2015 3990 C 2022 3965 2032 3928 2035 3907 C 2039 3887 2046 3867 2051 3864 C 2056 3861 2060 3850 2060 3838 C 2060 3815 2087 3753 2108 3728 C 2117 3717 2137 3710 2160 3710 C 2230 3710 2261 3780 2226 3862 C 2213 3893 2200 3936 2169 4050 C 2131 4190 2101 4444 2101 4620 C 2101 4743 2122 5010 2134 5028 C 2138 5034 2145 5067 2150 5102 C 2162 5192 2211 5365 2251 5465 C 2255 5476 2271 5514 2285 5550 C 2319 5633 2418 5830 2436 5851 C 2444 5859 2450 5869 2450 5873 C 2450 5876 2471 5909 2496 5947 C 2629 6141 2753 6284 2906 6417 C 3012 6510 3025 6520 3065 6548 C 3087 6563 3107 6578 3110 6581 C 3118 6590 3234 6664 3260 6676 C 3268 6680 3282 6689 3290 6696 C 3317 6718 3484 6800 3503 6800 C 3513 6800 3531 6790 3543 6777 C 3566 6753 3697 6650 3704 6650 C 3706 6650 3732 6634 3761 6614 C 3828 6568 4015 6479 4095 6455 C 4128 6445 4175 6431 4199 6424 C 4224 6416 4265 6410 4291 6410 C 4331 6410 4342 6414 4360 6438 C 4385 6469 4383 6529 4357 6558 C 4336 6582 4324 6666 4340 6685 C 4350 6697 4357 6696 4388 6675 C 4437 6641 4534 6640 4590 6671 C 4643 6701 4664 6691 4657 6640 C 4654 6618 4642 6582 4631 6560 C 4588 6476 4616 6410 4696 6410 C 4746 6411 4924 6458 4995 6489 C 5112 6542 5180 6576 5207 6596 C 5224 6609 5241 6620 5244 6620 C 5250 6620 5351 6690 5360 6700 C 5379 6721 5475 6790 5485 6790 C 5501 6790 5554 6766 5600 6738 C 5619 6727 5655 6707 5678 6694 C 5722 6670 5891 6561 5900 6550 C 5903 6547 5937 6520 5975 6490 C 6065 6421 6271 6215 6340 6125 C 6370 6087 6397 6053 6401 6050 C 6409 6043 6494 5918 6503 5900 C 6507 5892 6519 5872 6530 5855 C 6541 5839 6556 5812 6564 5795 C 6572 5779 6588 5749 6598 5730 C 6641 5654 6740 5422 6740 5398 C 6740 5392 6746 5374 6754 5357 C 6770 5320 6788 5256 6800 5187 C 6805 5161 6813 5125 6819 5107 C 6869 4942 6882 4515 6844 4280 C 6816 4106 6791 4005 6732 3821 C 6723 3794 6724 3781 6737 3756 C 6757 3716 6767 3710 6811 3710 C 6854 3710 6872 3728 6895 3790 C 6920 3859 6954 3977 6971 4060 C 6977 4085 6986 4125 6992 4150 C 7003 4195 7007 4230 7030 4470 C 7046 4641 7036 4828 6999 5045 C 6993 5078 6984 5128 6980 5157 C 6972 5208 6967 5229 6936 5326 C 6927 5355 6920 5383 6920 5390 C 6920 5397 6914 5416 6906 5433 C 6898 5451 6882 5493 6871 5528 C 6859 5562 6846 5598 6841 5608 C 6836 5617 6823 5648 6811 5675 C 6799 5703 6784 5734 6778 5745 C 6772 5756 6751 5794 6733 5830 C 6714 5866 6690 5909 6680 5925 C 6669 5942 6654 5969 6646 5985 C 6635 6009 6581 6087 6543 6135 C 6538 6141 6512 6174 6485 6210 C 6402 6320 6240 6489 6136 6575 C 6109 6597 6082 6620 6076 6625 C 6070 6631 6049 6646 6030 6660 C 6011 6673 5991 6688 5985 6692 C 5949 6721 5880 6770 5875 6770 C 5871 6770 5854 6781 5837 6794 C 5819 6808 5794 6823 5780 6829 C 5766 6835 5739 6850 5720 6861 C 5701 6873 5669 6890 5650 6900 C 5462 6995 5450 6997 5393 6947 C 5372 6928 5342 6902 5325 6887 C 5309 6873 5284 6852 5270 6840 C 5247 6819 5161 6761 5115 6734 C 5089 6719 4966 6659 4917 6637 C 4896 6628 4866 6620 4851 6620 C 4822 6620 4822 6620 4818 6693 C 4811 6792 4772 6874 4707 6921 C 4673 6946 4658 6951 4630 6946 C 4592 6940 4550 6901 4550 6871 C 4550 6845 4516 6818 4488 6822 C 4472 6824 4458 6839 4442 6871 C 4416 6924 4367 6956 4328 6947 C 4300 6940 4243 6889 4217 6848 C 4184 6794 4166 6727 4160 6628 C 4160 6617 4113 6618 4092 6629 C 4083 6634 4039 6655 3995 6676 C 3858 6740 3726 6830 3617 6934 C 3573 6976 3564 6980 3522 6979 C 3491 6979 3455 6969 3415 6949 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 0.42 -233.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4489.91, -6043.81)",
    d: "M 4465 6183 C 4451 6117 4439 6105 4377 6102 C 4329 6099 4320 6096 4320 6080 C 4320 6069 4335 6053 4360 6039 C 4405 6013 4411 5986 4384 5931 C 4375 5914 4371 5892 4374 5884 C 4379 5872 4389 5876 4426 5904 C 4452 5924 4478 5940 4485 5940 C 4491 5940 4514 5927 4536 5910 C 4557 5894 4581 5880 4588 5880 C 4602 5880 4604 5911 4591 5926 C 4587 5931 4580 5952 4577 5972 C 4572 6008 4574 6012 4616 6040 C 4678 6084 4675 6100 4602 6100 C 4540 6100 4520 6111 4520 6145 C 4520 6168 4494 6210 4480 6210 C 4475 6210 4468 6198 4465 6183 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -245.5 58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2645.55, -3860.55)",
    d: "M 1830 5938 C 1809 5915 1780 5858 1746 5770 C 1736 5745 1723 5716 1717 5705 C 1712 5694 1703 5672 1699 5655 C 1692 5624 1673 5570 1659 5535 C 1654 5524 1646 5497 1641 5475 C 1621 5394 1608 5344 1598 5312 C 1593 5293 1584 5255 1580 5227 C 1576 5198 1567 5148 1562 5115 C 1503 4754 1515 4298 1592 3985 C 1597 3963 1605 3927 1609 3905 C 1613 3883 1622 3849 1628 3830 C 1635 3811 1656 3743 1676 3680 C 1697 3617 1717 3561 1722 3556 C 1726 3550 1730 3540 1730 3533 C 1730 3490 1964 3034 1993 3022 C 1997 3020 2000 3014 2000 3009 C 2000 3000 2036 2944 2050 2930 C 2053 2927 2072 2900 2093 2869 C 2114 2838 2144 2799 2161 2781 C 2177 2763 2190 2746 2190 2742 C 2191 2726 2399 2509 2521 2398 C 2567 2355 2648 2289 2700 2250 C 2752 2211 2800 2176 2805 2172 C 2837 2148 2962 2069 3000 2049 C 3025 2036 3047 2022 3050 2019 C 3056 2011 3310 1889 3370 1865 C 3395 1855 3429 1841 3447 1834 C 3464 1826 3484 1820 3492 1820 C 3500 1820 3510 1816 3516 1811 C 3529 1799 3659 1760 3685 1760 C 3715 1760 3756 1794 3764 1825 C 3777 1877 3735 1919 3648 1940 C 3630 1945 3590 1958 3560 1970 C 3530 1982 3494 1995 3480 2000 C 3445 2011 3353 2053 3235 2112 C 3127 2165 3117 2171 3052 2213 C 3028 2228 3007 2240 3004 2240 C 3002 2240 2982 2252 2961 2268 C 2940 2283 2912 2302 2900 2310 C 2746 2413 2483 2651 2365 2793 C 2343 2820 2320 2847 2315 2853 C 2288 2883 2180 3030 2180 3035 C 2180 3039 2167 3059 2152 3079 C 2136 3099 2120 3122 2117 3130 C 2113 3138 2101 3159 2091 3175 C 2034 3264 1880 3575 1880 3602 C 1880 3607 1874 3626 1866 3643 C 1845 3691 1790 3856 1790 3873 C 1790 3881 1784 3910 1776 3936 C 1732 4091 1712 4221 1698 4444 C 1683 4706 1704 5051 1746 5196 C 1753 5224 1760 5257 1760 5270 C 1760 5282 1767 5313 1774 5339 C 1782 5364 1797 5412 1806 5445 C 1822 5502 1831 5530 1864 5618 C 1887 5680 1921 5762 1946 5817 C 1976 5882 1976 5891 1944 5929 C 1912 5968 1862 5972 1830 5938 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 245.68 57.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6329.4, -3860.62)",
    d: "M 7032 5937 C 7006 5910 7003 5853 7023 5812 C 7042 5776 7064 5724 7085 5670 C 7094 5645 7108 5610 7116 5592 C 7124 5574 7130 5555 7130 5549 C 7130 5543 7136 5524 7144 5507 C 7151 5489 7162 5455 7169 5430 C 7175 5405 7188 5360 7196 5330 C 7205 5300 7215 5250 7220 5220 C 7224 5190 7233 5145 7239 5120 C 7278 4957 7292 4538 7265 4325 C 7257 4254 7245 4175 7239 4150 C 7233 4125 7224 4080 7219 4050 C 7203 3944 7154 3769 7113 3673 C 7106 3656 7100 3637 7100 3631 C 7100 3625 7096 3612 7090 3602 C 7085 3593 7069 3556 7054 3520 C 7026 3449 6955 3305 6922 3250 C 6910 3231 6896 3206 6891 3195 C 6886 3184 6870 3158 6856 3137 C 6842 3116 6830 3097 6830 3094 C 6830 3091 6825 3084 6820 3077 C 6814 3070 6775 3018 6732 2960 C 6589 2765 6452 2616 6300 2489 C 6264 2459 6233 2433 6230 2430 C 6211 2409 5975 2240 5965 2240 C 5963 2240 5942 2228 5918 2213 C 5853 2171 5843 2165 5735 2112 C 5647 2068 5580 2037 5515 2011 C 5504 2006 5478 1995 5457 1986 C 5436 1977 5415 1970 5409 1970 C 5403 1970 5384 1964 5367 1956 C 5349 1949 5317 1938 5295 1931 C 5237 1916 5210 1887 5210 1842 C 5210 1815 5217 1800 5237 1783 C 5271 1753 5301 1754 5386 1786 C 5424 1800 5469 1815 5485 1819 C 5502 1823 5524 1832 5535 1837 C 5546 1843 5575 1856 5600 1866 C 5773 1933 6148 2141 6195 2194 C 6201 2201 6221 2216 6240 2227 C 6259 2239 6286 2259 6300 2272 C 6314 2285 6348 2313 6375 2335 C 6503 2436 6701 2638 6797 2765 C 6909 2912 7003 3051 7060 3153 C 7113 3248 7205 3441 7235 3520 C 7245 3545 7256 3574 7261 3585 C 7270 3608 7299 3695 7325 3785 C 7335 3818 7347 3856 7352 3870 C 7356 3884 7365 3918 7370 3945 C 7375 3973 7383 4018 7389 4045 C 7430 4253 7458 4581 7446 4726 C 7442 4775 7435 4871 7430 4940 C 7425 5009 7417 5078 7411 5093 C 7405 5109 7400 5135 7400 5152 C 7400 5183 7380 5285 7355 5375 C 7335 5452 7248 5722 7235 5750 C 7228 5764 7215 5793 7205 5815 C 7175 5883 7158 5914 7137 5938 C 7110 5968 7060 5967 7032 5937 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -0.24 50.53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4485, -3916.53)",
    d: "M 4445 5631 C 4429 5621 4043 5239 3588 4783 C 2774 3967 2760 3953 2760 3915 C 2760 3876 2774 3862 3602 3033 C 4065 2570 4454 2189 4466 2186 C 4478 2183 4499 2184 4512 2189 C 4532 2197 6180 3838 6201 3872 C 6206 3879 6210 3901 6210 3920 C 6210 3953 6174 3991 5603 4563 C 4641 5526 4542 5623 4518 5637 C 4487 5654 4480 5653 4445 5631 z M 5251 4679 C 5663 4265 6000 3922 6000 3916 C 6000 3904 4500 2390 4489 2390 C 4481 2390 2976 3899 2971 3911 C 2966 3927 4461 5426 4483 5428 C 4495 5429 4763 5167 5251 4679 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -41.24 51.04)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4177.5, -3912.76)",
    d: "M 4153 4733 C 4098 4723 4100 4749 4100 3912 L 4100 3139 L 4126 3115 C 4158 3085 4196 3083 4230 3110 L 4255 3129 L 4255 3914 C 4255 4599 4253 4701 4240 4713 C 4222 4730 4184 4738 4153 4733 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 41.09 50.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4795, -3913.57)",
    d: "M 4762 4733 C 4709 4723 4710 4732 4710 3916 C 4710 3384 4713 3154 4721 3137 C 4745 3085 4808 3077 4851 3119 L 4880 3148 L 4880 3914 L 4880 4679 L 4858 4703 C 4834 4729 4800 4740 4762 4733 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -122.91 51.34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-3565, -3910.48)",
    d: "M 3506 4175 L 3480 4147 L 3480 3924 C 3480 3781 3484 3692 3491 3676 C 3497 3663 3517 3644 3535 3634 C 3568 3617 3569 3617 3604 3640 C 3623 3654 3641 3674 3644 3685 C 3647 3696 3650 3804 3650 3925 C 3649 4128 3648 4147 3630 4168 C 3618 4183 3595 4194 3571 4197 C 3537 4202 3528 4199 3506 4175 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 123.16 50.97)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-5410.5, -3913.27)",
    d: "M 5356 4179 L 5330 4159 L 5330 3916 L 5330 3673 L 5355 3650 C 5387 3620 5434 3619 5463 3649 C 5484 3670 5485 3679 5488 3910 L 5491 4150 L 5466 4175 C 5435 4206 5392 4208 5356 4179 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -101.57 -152.05)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-3725, -5435.88)",
    d: "M 3693 5543 L 3673 5485 L 3611 5482 C 3578 5480 3550 5475 3550 5471 C 3550 5466 3568 5450 3590 5435 C 3639 5401 3643 5387 3625 5327 C 3612 5285 3612 5278 3626 5273 C 3634 5270 3646 5274 3653 5282 C 3660 5291 3679 5306 3697 5316 C 3727 5333 3730 5333 3748 5317 C 3758 5308 3770 5300 3775 5300 C 3780 5300 3791 5293 3801 5284 C 3831 5257 3840 5276 3825 5328 C 3804 5395 3805 5397 3855 5432 C 3880 5450 3900 5467 3900 5471 C 3900 5476 3872 5480 3838 5482 L 3775 5485 L 3756 5543 C 3745 5574 3731 5600 3725 5600 C 3719 5600 3705 5574 3693 5543 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 101.06 -151.71)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-5244.73, -5433.38)",
    d: "M 5225 5566 C 5217 5547 5210 5524 5210 5516 C 5210 5493 5177 5480 5121 5480 C 5093 5480 5070 5476 5070 5471 C 5070 5466 5087 5451 5108 5439 C 5128 5426 5149 5411 5153 5406 C 5163 5392 5152 5309 5138 5293 C 5131 5284 5132 5278 5144 5274 C 5153 5270 5175 5280 5199 5299 C 5237 5329 5265 5338 5272 5323 C 5277 5311 5338 5270 5351 5270 C 5364 5270 5354 5337 5338 5357 C 5322 5377 5339 5409 5381 5433 C 5437 5465 5432 5480 5365 5480 C 5314 5480 5309 5482 5293 5513 C 5283 5530 5273 5556 5270 5569 C 5262 5607 5241 5606 5225 5566 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -187.68 -69.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-3079.18, -4819.44)",
    d: "M 3054 4953 C 3042 4887 3036 4881 2968 4878 C 2934 4876 2905 4871 2904 4865 C 2902 4860 2921 4840 2946 4821 C 2989 4790 2991 4785 2986 4754 C 2983 4735 2977 4704 2974 4685 C 2970 4662 2972 4650 2979 4650 C 2985 4650 2990 4653 2990 4658 C 2990 4672 3056 4710 3081 4710 C 3095 4710 3125 4696 3148 4679 C 3197 4643 3201 4652 3174 4730 L 3158 4775 L 3210 4820 C 3238 4845 3258 4869 3254 4873 C 3250 4877 3221 4880 3189 4880 C 3125 4880 3120 4884 3105 4945 C 3091 5000 3064 5004 3054 4953 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 188.19 -70.04)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-5898.25, -4820.87)",
    d: "M 5877 4983 C 5873 4980 5870 4965 5870 4951 C 5870 4936 5863 4914 5854 4902 C 5842 4884 5829 4880 5785 4880 C 5755 4880 5728 4875 5724 4868 C 5717 4857 5726 4848 5784 4806 C 5814 4784 5816 4767 5794 4715 C 5768 4653 5782 4643 5838 4683 C 5891 4722 5904 4721 5966 4674 C 5985 4659 6003 4650 6007 4653 C 6010 4657 6006 4683 5997 4711 C 5987 4739 5980 4768 5980 4774 C 5980 4780 6003 4803 6031 4824 C 6059 4845 6078 4866 6074 4870 C 6069 4875 6036 4880 6000 4882 L 5936 4885 L 5928 4924 C 5917 4977 5895 5002 5877 4983 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -1.43 334.01)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(241,225,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4476.05, -1790.45)",
    d: "M 4153 1963 C 4145 1960 4140 1938 4140 1905 C 4140 1820 4140 1820 4045 1820 C 3968 1820 3961 1818 3954 1798 C 3944 1765 3973 1750 4051 1750 C 4093 1750 4121 1745 4128 1737 C 4134 1730 4140 1700 4142 1670 L 4145 1615 L 4479 1612 C 4698 1611 4817 1613 4824 1620 C 4830 1626 4833 1648 4831 1670 C 4827 1726 4851 1723 4916 1659 C 4996 1580 5000 1585 5000 1789 C 5000 1902 4996 1961 4989 1966 C 4983 1969 4953 1947 4921 1916 C 4890 1885 4856 1860 4846 1860 C 4830 1860 4828 1865 4834 1901 C 4845 1972 4857 1970 4491 1969 C 4312 1969 4159 1966 4153 1963 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFjfs);
export default __webpack_public_path__ + "static/media/fjfs.0fc3f6aca1f49c16f40a0c37d1aa047a.svg";
export { ForwardRef as ReactComponent };